import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import {
  CreateAccountComponent as SharedCreateAccountComponent,
  FormStepSingleRouteService,
  AjaxHandlerService,
  TranslationService,
  BrandService,
  RegistrationProvidersService,
} from '@whitehatgaming/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { filter, map } from 'rxjs/operators';

const wzshared = require('@whitezipmedia/whitezip-libs/index');

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent extends SharedCreateAccountComponent implements OnInit {
  @Output() public messageEvent: EventEmitter<string> = new EventEmitter<string>();
  public storedTheme: string = localStorage.getItem('theme-color');
  public isOntario: boolean = false;
  public shouldShowTrustlyRegButton: boolean = false;
  public welcomePromoterms: string;
  public termsPromotional: string;
  public heroUpTo: string;
  public welcomeBonus: string;
  public fullTermsBellow: string;
  public termsVersion: string;
  public logos: object;

  constructor(
    formStepSingleRoute: FormStepSingleRouteService,
    activatedRoute: ActivatedRoute,
    router: Router,
    ajaxHandler: AjaxHandlerService,
    cookieService: CookieService,
    private cookie: CookieService,
    brand: BrandService,
    private translation: TranslationService,
    registrationProviders: RegistrationProvidersService
  ) {
    super(formStepSingleRoute, activatedRoute, router, ajaxHandler, cookieService, brand, registrationProviders);
      const contentServiceParams = {
          values: ['first_deposit'],
          text: ['terms_promotional', 'WELCOME_BODYCOPY_SHORT', 'WELCOME_BODYCOPY', 'FULL_TERMS_BELOW', 'l_terms_version'],
          terms: ['WELCOME_FULL_TERMS'],
      };

      wzshared.contentService.init(contentServiceParams).then((contentResponse) => {
          this.termsPromotional = contentResponse.text.terms_promotional;
          this.heroUpTo = contentResponse.text.WELCOME_BODYCOPY_SHORT;
          this.welcomeBonus = contentResponse.text.WELCOME_BODYCOPY;
          this.fullTermsBellow = contentResponse.text.FULL_TERMS_BELOW;
          this.welcomePromoterms = contentResponse.terms.WELCOME_FULL_TERMS;
          this.termsVersion = contentResponse.text.l_terms_version;
      });

    this.registrationProviders.getProviders().subscribe((providers: any) => {
      this.shouldShowTrustlyRegButton = providers.pnpStyle && providers.pnpStyle === 'HYBRID';
    });
    this.logos = this.getLogos();
  }

  public ngOnInit(): void {
    this.activatedRoute.data
      .pipe(
        filter((data: any) => data.jurisdiction),
        map((data: any) => data.jurisdiction)
      )
      .subscribe((data: string) => {
        this.isOntario = !!data;
      });
  }

  public setTheme(): void {
    const container: Element = document.getElementsByClassName('content')[0];

    if (this.storedTheme === 'theme-dark') {
      localStorage.setItem('theme-color', 'theme-light');
      this.storedTheme = localStorage.getItem('theme-color');
      this.cookieService.set('theme', 'light', 365);
      container.classList.remove('theme-dark');
      container.classList.add('theme-light');
    } else {
      localStorage.setItem('theme-color', 'theme-dark');
      this.storedTheme = localStorage.getItem('theme-color');
      this.cookieService.set('theme', 'dark', 365);
      container.classList.remove('theme-light');
      container.classList.add('theme-dark');
    }
  }

  public goToWoTerms(): void {
    document.getElementById('wo-terms').scrollIntoView();
  }

  public makeRegFormVisible(): void {
    document.querySelector('.normal-reg-show-btn').classList.add('d-none');
    document.getElementById('reg-form-normal').classList.remove('d-none');
    document.getElementById('reg-form-normal').scrollIntoView();
  }

  public getLogos() {
    const logos = [
      {icon: 'fast-charge.png', text: 'create-account-fast', classNameUsp: 'usp-fast'},
      {icon: 'lock.png', text: 'create-account-secure', classNameUsp: 'usp-secure'},
      {icon: 'safe.png', text: 'create-account-247-support', classNameUsp: 'usp-support'},
      {icon: 'mga.png', classNameUsp: 'usp-mga'},
      {icon: 'ukgc.png', classNameUsp: 'usp-ukgc'},
    ];

    return logos;
  }

  public onClickNext(event) {
    if(this.router.url === '/create-account/success' || this.router.url === '/create-account/failed' ){
      document.querySelector('.form_header').scrollIntoView();
    }
  }
}
